module.exports = __webpack_public_path__ + "static/img/back_small.c509d9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back_small.svg
// module id = KRQX
// module chunks = 1